import { Component, OnInit, ViewChild, OnDestroy } from "@angular/core";
import { Utils } from "src/app/shared/utils/utils";
import { Subscription, Subject } from "rxjs";
import { CollaborateurService } from "../../services/collaborateur.service";
import { Router } from "@angular/router";
import { DataTableDirective } from "angular-datatables";

declare let swal: any;

@Component({
  selector: "app-list-collaborateur",
  templateUrl: "./collaborateur-list.component.html",
  styleUrls: ["./collaborateur-list.component.css"],
})
export class ListCollaborateurComponent implements OnInit, OnDestroy {

  collaborateurs: any[] = [];
  sousCollaborateurs: any[] = [];
  selectedCollaborateur: any = null;
  busy: Subscription;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();
  isDtInitialized: boolean = false;

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;

  constructor(
    private collaborateurService: CollaborateurService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadCollaborateurs();
    this.initDtOptions();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  // -------------------------------------------------------
  // Init DataTable options
  // -------------------------------------------------------
  initDtOptions(): void {
    this.dtOptions = {
      dom: "['<l>', Bfrtip']",
      buttons: ["colvis"],
      pagingType: "full_numbers",
      pageLength: 10,
      data: [],
      aLengthMenu: [
        [5, 10, 25, 50],
        [5, 10, 25, 50],
      ],
      columns: [
        { data: "id" },
        { data: "prenom" },
        { data: "nom",   render: (data, type, row) => row.nom   ?? "-" },
        { data: "email", render: (data, type, row) => row.email ?? "-" },
        { data: "poste", render: (data, type, row) => row.poste ?? "-" },
        {
          data: null,
          render: () => `
            <button class="btn btn-xs btn-warning action-btn me-1" action-id="1">
              <i class="icon-pencil3"></i> Edit
            </button>
            <button class="btn btn-xs btn-danger action-btn ml-1" action-id="2">
              <i class="icon-trash"></i> Supprimer
            </button>
          `,
        },
      ],
      rowCallback: (row: Node, data: any) => {
        jQuery(".action-btn", row).unbind("click");
        jQuery(".action-btn", row).bind("click", (event) => {
          const actionId = parseInt(
            $(event.target).closest("[action-id]").attr("action-id"),
            10
          );
          this.goToAction(actionId, data);
        });
      },
    };
  }

  // -------------------------------------------------------
  // Charger les collaborateurs parents (fixes)
  // -------------------------------------------------------
  loadCollaborateurs(): void {
    this.busy = this.collaborateurService.getAll().subscribe(
      (data: any) => {
        this.collaborateurs = data;
      },
      () => {
        Utils.sweetAlert("error", "Erreur", "Erreur lors du chargement des collaborateurs");
      }
    );
  }

  // -------------------------------------------------------
  // Charger les sous-collaborateurs d'un collaborateur
  // -------------------------------------------------------
  selectCollaborateur(collab: any): void {
    this.selectedCollaborateur = collab;
    this.busy = this.collaborateurService.getSousCollaborateurs(collab.id).subscribe(
      (data: any) => {
        this.sousCollaborateurs = data.sous_collaborateurs;

        // Mettre à jour les données AVANT le trigger
        this.dtOptions = {
          ...this.dtOptions,
          data: this.sousCollaborateurs,
        };

        if (this.isDtInitialized) {
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            setTimeout(() => {
              this.dtTrigger.next(null);
            }, 100);
          });
        } else {
          this.isDtInitialized = true;
          setTimeout(() => {
            this.dtTrigger.next(null);
          }, 100);
        }
      },
      () => {
        Utils.sweetAlert("error", "Erreur", "Erreur lors du chargement des sous-collaborateurs");
      }
    );
  }

  // -------------------------------------------------------
  // Actions Edit / Delete
  // -------------------------------------------------------
  private goToAction(actionId: number, data: any) {
    switch (actionId) {
      case 1:
        this.router.navigate(["/collaborateurs", data.id, "edit"]);
        break;
      case 2:
        this.removeSousCollaborateur(data.id);
        break;
    }
  }

  removeSousCollaborateur(id: number) {
    swal({
      title: "Êtes-vous sûr ?",
      text: "Cette action est irréversible !",
      icon: "warning",
      buttons: ["Annuler", "Supprimer"],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        this.busy = this.collaborateurService.delete(id).subscribe(
          () => {
            Utils.sweetAlert("success", "Succès", "Sous-collaborateur supprimé avec succès");
            this.selectCollaborateur(this.selectedCollaborateur);
          },
          () => {
            Utils.sweetAlert("error", "Erreur", "Erreur lors de la suppression");
          }
        );
      }
    });
  }
}